module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-3-photo-7-6b79de1fafd24de92982b91685b62290.webp";